import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "whole-page-mobile"
}
const _hoisted_2 = {
  key: 0,
  class: "succes"
}
const _hoisted_3 = {
  key: 1,
  class: "error"
}
const _hoisted_4 = {
  key: 1,
  class: "whole-page"
}
const _hoisted_5 = {
  key: 0,
  class: "succes"
}
const _hoisted_6 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.type == 'succes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[4] || (_cache[4] = _createElementVNode("img", {
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/check.svg",
                  class: "succes-filter"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
                _createElementVNode("img", {
                  class: "X",
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearToast()))
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/cross.svg",
                  class: "error-filter"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
                _createElementVNode("img", {
                  class: "X",
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearToast()))
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.type == 'succes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/check.svg",
                  class: "succes-filter"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
                _createElementVNode("img", {
                  class: "X",
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearToast()))
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.type == 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.5/cross.svg",
                  class: "error-filter"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
                _createElementVNode("img", {
                  class: "X",
                  src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Navigation/cross.svg",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearToast()))
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}